import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'
import {
  getPackagePermissionsFromRoute, isSubscriptionHasPermissions,
} from '@/utils/permissions-helper'
// @ts-ignore

function PackagePermissionsGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (!store.getters['subscription/isCustom']) {
    return next()
  }

  const permissions = getPackagePermissionsFromRoute(to)
  const canAccessFeature = store.getters['subscription/canAccessFeature']
  if (!isSubscriptionHasPermissions(permissions, canAccessFeature)) {
    return next({ name: 'billing:plans' })
  }

  return next()
}
export default PackagePermissionsGuard
